<h2 class="m-0 text-center text-sm-left">
  {{'COMMON.LABEL.NEWSLETTER_TITLE' | translate}}
</h2>
<button mat-icon-button
  class="close-dialog"
  (click)="onCancel()">
  <mat-icon>close</mat-icon>
</button>

<cci-newsletter (subscribed)="onSubscribed()"></cci-newsletter>